import { useGetCollectionsSummaryQuery, useGetPatientsSummaryQuery } from 'services'

export const useGetFilesSummary = ({ type, id, query, fileIds = [] }) => {
    const queries = {
        patient: useGetPatientsSummaryQuery,
        collection: useGetCollectionsSummaryQuery,
    }

    const callback = queries[type]

    const response = callback && callback({ id, query }, { skip: !id })

    return response?.data?.all || fileIds.length
}
